module.exports = __webpack_public_path__ + "d7778db87207fb9cf8e5c252cb0327d1.svg";